'use client'

import { PostProcessor } from '.'

const setAriaExpanded = (btn: Element) => {
  const expanded = btn.getAttribute('aria-expanded')

  if (expanded == 'false') {
    btn.setAttribute('aria-expanded', 'true')
  } else {
    btn.setAttribute('aria-expanded', 'false')
  }
}

/**
 * @param root Root element to parse.
 * @returns
 */
const attachAccordionControls = (root: Element) => {
  const accordion = root.getElementsByClassName('c-accordion')
  // If page contains any accordions
  if (accordion) {
    for (const btnContainer of accordion) {
      const aBtn = btnContainer.getElementsByClassName('c-accordion__btn')[0] as HTMLElement
      // Only apply click listener if button hasn't recieved one
      if (aBtn && !aBtn.onclick) {
        aBtn.onclick = () => {
          // Toggle accordion
          setAriaExpanded(aBtn)
          const el = aBtn.closest('.c-accordion')
          el?.classList.toggle('c-accordion--active')
        }
      }
    }
  }
}

export const accordionProcessor: PostProcessor = node => {
  attachAccordionControls(node)
}
